import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import MyNavbar from '../../../components/Customer/Mynavbar/MyNavbar';
import Footer from '../../../components/Customer/Footer/Footer';
import AppContext from '../../../context/AppContext';
import '../../../assests/css/customer/ProductDetailPage.css';

const ProductDetailPage = () => {
  const navigate = useNavigate();
  const { productId } = useParams();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode'); // 'tryon' | 'customize' | null

  const { baseUrl, baseUrlForFiles, setCartCount } = useContext(AppContext);
  const customer = JSON.parse(localStorage.getItem('loggedInCustomer'));
  const MlcustomerId = customer?.id;

  const [product, setProduct]           = useState(null);
  const [loading, setLoading]           = useState(true);
  const [selectedColor, setSelectedColor] = useState(0);
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity]         = useState(1);
  const [stitchingType, setStitchingType] = useState('stitched');
  const [activeThumb, setActiveThumb]   = useState(0);
  const [cartLoading, setCartLoading]   = useState(false);
  const [cartSuccess, setCartSuccess]   = useState(false);

  useEffect(() => {
    axios
      .post(`${baseUrl}/customer/products/getProductDetail`, { product_id: productId })
      .then((res) => { setProduct(res.data.product); setLoading(false); })
      .catch(() => setLoading(false));
  }, [productId, baseUrl]);

  const handleQty = (d) => setQuantity((q) => Math.max(1, q + d));

  const cartPayload = (thumbnails, colors) => ({
    title:         product.name,
    price:         product.enable_sale && product.discount_price
      ? product.discount_price
      : product.base_price,
    quantity,
    image_path:    thumbnails[0]?.src || null,
    color:         colors[selectedColor] || 'Default',
    size:          selectedSize || 'M',
    Mlproduct_id:  product.id,
    Mlcustomer_id: MlcustomerId,
  });

  const handleAddToCart = async (thumbnails, colors) => {
    if (!MlcustomerId) {
      Swal.fire({ icon: 'warning', title: 'Login Required', text: 'Please login first.' });
      return;
    }
    setCartLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/customer/cart/addtocart`, cartPayload(thumbnails, colors));
      if (res.data.success) {
        setCartSuccess(true);
        setCartCount((p) => p + quantity);
        setTimeout(() => setCartSuccess(false), 3000);
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Oops!', text: 'Failed to add to cart.' });
    } finally {
      setCartLoading(false);
    }
  };

  const handleBuyNow = async (thumbnails, colors) => {
    if (!MlcustomerId) {
      Swal.fire({ icon: 'warning', title: 'Login Required', text: 'Please login first.' });
      return;
    }
    setCartLoading(true);
    try {
      const res = await axios.post(`${baseUrl}/customer/cart/addtocart`, cartPayload(thumbnails, colors));
      if (res.data.success) {
        setCartCount((p) => p + quantity);
        navigate('/checkout');
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Oops!', text: 'Failed. Try again.' });
    } finally {
      setCartLoading(false);
    }
  };

  if (loading) return (
    <><MyNavbar /><div className="pdp-loading">Loading product...</div><Footer /></>
  );
  if (!product) return (
    <><MyNavbar /><div className="pdp-loading">Product not found.</div><Footer /></>
  );

  const thumbnails = product.images?.length > 0
    ? product.images.map((img) => ({
        src: `${baseUrlForFiles}/${img.image_path}`,
      }))
    : [{ src: null }];

  const colors = product.variant?.colors?.split(',').filter(Boolean) || [];
  const sizes  = product.variant?.sizes?.split(',').filter(Boolean)  || [];
  const mainImg = thumbnails[activeThumb]?.src || thumbnails[0]?.src;

  // ── PRICE LOGIC (FIXED) ──
  // discount_price = jo customer asal mein pay karega (chota amount)
  // base_price     = original price (strikethrough)
  const hasSale = product.enable_sale && product.discount_price
    && Number(product.discount_price) < Number(product.base_price);

  const displayPrice = hasSale ? product.discount_price : product.base_price;
  const originalPrice = product.base_price;

  const discount = hasSale
    ? Math.round(((originalPrice - product.discount_price) / originalPrice) * 100)
    : null;

  return (
    <>
      <MyNavbar />

      <div className="pdp-page">
      <div className="pdp-wrapper">

        {/* ════ LEFT — Gallery ════ */}
        <div className="pdp-gallery">
          <div className="pdp-thumbs">
            {thumbnails.map((t, i) => (
              <button
                key={i}
                className={`pdp-thumb-btn ${activeThumb === i ? 'active' : ''}`}
                onClick={() => setActiveThumb(i)}
              >
                {t.src
                  ? <img src={t.src} alt={product.name} />
                  : <div className="pdp-thumb-empty" />
                }
              </button>
            ))}
          </div>

          <div className="pdp-main-img-wrap">
            {hasSale && <span className="pdp-discount-badge">{discount}% OFF</span>}

            {mode === 'tryon' && (
              <span className="pdp-mode-badge pdp-mode-badge--tryon">Virtual Try-On</span>
            )}
            {mode === 'customize' && (
              <span className="pdp-mode-badge pdp-mode-badge--customize">Customization</span>
            )}

            {mainImg
              ? <img src={mainImg} alt={product.name} className="pdp-main-img" />
              : <div className="pdp-no-image">No Image</div>
            }
          </div>
        </div>

        {/* ════ RIGHT — Details ════ */}
        <div className="pdp-details">

          {/* Mode Banner */}
          {mode === 'tryon' && (
            <div className="pdp-mode-banner pdp-mode-banner--tryon">
              <span className="pdp-mode-banner-icon">👗</span>
              <div>
                <p className="pdp-mode-banner-title">Virtual Try-On</p>
                <p className="pdp-mode-banner-sub">See how this outfit looks on you before buying</p>
              </div>
            </div>
          )}
          {mode === 'customize' && (
            <div className="pdp-mode-banner pdp-mode-banner--customize">
              <span className="pdp-mode-banner-icon">✏️</span>
              <div>
                <p className="pdp-mode-banner-title">Customization</p>
                <p className="pdp-mode-banner-sub">Personalize this outfit to match your style</p>
              </div>
            </div>
          )}

          <h1 className="pdp-title">{product.name}</h1>

          {/* ── PRICE ROW (FIXED) ── */}
          <div className="pdp-price-row">
            <span className="pdp-price">
              Rs. {parseFloat(displayPrice).toLocaleString()}
            </span>
            {hasSale && (
              <>
                <span className="pdp-original-price">
                  Rs. {parseFloat(originalPrice).toLocaleString()}
                </span>
                <span className="pdp-save-tag">{discount}% OFF</span>
              </>
            )}
          </div>

          <p className="pdp-desc">{product.description}</p>

          <div className="pdp-divider" />

          {/* Stitching — hide in tryon mode; sirf product ka apna type dikhao, toggle nahi */}
          {mode !== 'tryon' && (
            <>
              <p className="pdp-label">Stitching Type</p>
              <div className="pdp-stitch-row">
                <button className="pdp-size-btn active" disabled>
                  {product.type === 'unstitched' ? 'Unstitched' : 'Stitched'}
                </button>
              </div>
            </>
          )}

          {/* Color */}
          {colors.length > 0 && (
            <>
              <p className="pdp-label">
                Color <span className="pdp-label-val">{colors[selectedColor]}</span>
              </p>
              <div className="pdp-colors">
                {colors.map((c, i) => (
                  <button
                    key={i}
                    className={`pdp-color-btn ${selectedColor === i ? 'active' : ''}`}
                    style={{ background: c }}
                    onClick={() => setSelectedColor(i)}
                    title={c}
                  />
                ))}
              </div>
            </>
          )}

          {/* Size */}
          {sizes.length > 0 && (
            <>
              <p className="pdp-label">
                Size <span className="pdp-label-val">{selectedSize}</span>
              </p>
              <div className="pdp-sizes">
                {sizes.map((s, i) => (
                  <button
                    key={i}
                    className={`pdp-size-btn ${selectedSize === s ? 'active' : ''}`}
                    onClick={() => setSelectedSize(s)}
                  >{s}</button>
                ))}
              </div>
            </>
          )}

          {/* Quantity — only in default mode */}
          {!mode && (
            <div className="pdp-qty-row">
              <p className="pdp-label" style={{ margin: 0 }}>Quantity</p>
              <div className="pdp-qty-controls">
                <button className="pdp-qty-btn" onClick={() => handleQty(-1)}>−</button>
                <span className="pdp-qty-value">{quantity}</span>
                <button className="pdp-qty-btn" onClick={() => handleQty(+1)}>+</button>
              </div>
            </div>
          )}

          <div className="pdp-divider" />

          {/* ── ACTION BUTTONS ── */}
          {mode === 'tryon' && (
            <div className="pdp-actions">
              <button
                className="pdp-btn pdp-btn--tryon"
                onClick={() => navigate('/try-on')}
              >
                👗 Start Virtual Try-On
              </button>
              <button
                className="pdp-btn pdp-btn--buy"
                onClick={() => handleBuyNow(thumbnails, colors)}
                disabled={cartLoading}
              >
                {cartLoading ? 'Processing...' : 'Buy Now'}
              </button>
            </div>
          )}

          {mode === 'customize' && (
            <div className="pdp-actions">
              <button
                className="pdp-btn pdp-btn--customize"
                onClick={() => navigate('/dress-customize')}
              >
                ✏️ Start Customization
              </button>
              <button
                className="pdp-btn pdp-btn--buy"
                onClick={() => handleBuyNow(thumbnails, colors)}
                disabled={cartLoading}
              >
                {cartLoading ? 'Processing...' : 'Buy Now'}
              </button>
            </div>
          )}

          {!mode && (
            <div className="pdp-actions">
              <button
                className={`pdp-btn pdp-btn--cart ${cartLoading ? 'loading' : ''} ${cartSuccess ? 'success' : ''}`}
                onClick={() => handleAddToCart(thumbnails, colors)}
                disabled={cartLoading}
              >
                {cartLoading ? (
                  <span className="pdp-btn-spinner" />
                ) : cartSuccess ? (
                  '✓ Added to Cart'
                ) : (
                  'Add to Cart'
                )}
              </button>
              <button
                className="pdp-btn pdp-btn--buy"
                onClick={() => handleBuyNow(thumbnails, colors)}
                disabled={cartLoading}
              >
                {cartLoading ? 'Processing...' : 'Buy Now'}
              </button>
            </div>
          )}

        </div>
      </div>
      </div>

      <Footer />
    </>
  );
};

export default ProductDetailPage;